var howler = require('howler');
var Howl = howler.Howl;
var common = require('./common');

module.exports = function($) {

  function Game(gameOpts) {
    this.baseList = gameOpts.baseList;
    this.baseList.forEach(function(question) {
      if(question.wordSoundUrl) {
        question.wordSound = new Howl({
          src: [question.wordSoundUrl]
        });
      }
      if(question.definitionSoundUrl) {
        question.definitionSound = new Howl({
          src: [question.definitionSoundUrl]
        });
      }
    });
    this.instructions = new Howl({
      src: [gameOpts.instruct]
    });
  }

  Game.prototype.start = function() {
    this.questionList = common.shuffle(this.baseList);
    this.nextQuestion();
  };

  Game.prototype.nextQuestion = function() {
    if(!this.questionList.length) {
      this.win();
      return false;
    }
    this.curQuestion = this.questionList.pop();
    return true;
  };

  return Game;
};
